export default "__VITE_ASSET__CiQgZ0$Y__"